import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import { css } from "styled-components";

myListsEditListFormStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 20px;
    `,
};
